module.exports = __webpack_public_path__ + "assets/img/ad51bdff814c3457e9d9b10734c3e8ca.svg";